import { render, staticRenderFns } from "./CompanyGovernmentHolidays.vue?vue&type=template&id=19b8fe08"
import script from "./CompanyGovernmentHolidays.vue?vue&type=script&lang=js"
export * from "./CompanyGovernmentHolidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports